<template>
  <div class="wrapper">
    <Hero
      background-image="https://images.unsplash.com/photo-1520372561567-bac27b0e5fa1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2048&q=80"
    >
      <Card>
        <template v-slot:title>
          <Title
            title="Rent 2 Rent Properties"
            subtitle="Guaranteed Rent Payments"
            class="bg-brown f-white"
          />
        </template>
        <template v-slot:content>
          <p>DOD Property Services is a family-run company that was established in 2015. It started out as a Property Maintenance business that would fulfil all internal and external property needs for homeowners, letting agents, property developers – basically anyone who owned a private or commercial property!</p>
          <p>Todd is the founder and co-owner of the business, but more importantly the face of the business. Carpenter by trade, Todd has been using his skills in property maintenance for several years until he opened up his own company and started to build a team of like-minded professionals to fulfil all our clientele needs in terms of maintenance.</p>
          <p>Passionate about property, DOD has now branched out into what is known as “Guaranteed Rental Agreements” or “Rent to Rent Agreements”. We have opened up a whole new arm of the business so we are not only doing property maintenance, we are now in the business of rentals too!</p>
          <p>In affiliation with a local housing association, DOD Property Services will take any property off your hands within the Birmingham area and give you guaranteed rent for a fixed period.</p>
        </template>
      </Card>
    </Hero>

    <section class="section">
      <div class="container">
        <Title title="FAQ" subtitle="Frequently Asked Questions" />
        <Card v-for="(faq, index) in FAQ" :key="index" :title="faq.question">
          <template v-slot:title>
            <FAQTitle
              :title="faq.question"
              class="bg-brown f-white"
            />
          </template>
          <template v-slot:content>
            <div v-html="faq.answer" class="card-content has-text-left" />
          </template>
        </Card>
      </div>
      <div class="container box" id="interested">
        <p>
          Are you interested? If so then please contact Sarah or Todd at
          <a
            href="mailto:dodpropertyservices@gmail.com"
          >dodpropertyservices@gmail.com</a>. If you want to provide your contact information and any questions you may have and then we will get in touch.
        </p>
      </div>
    </section>

    <div class="container">
      <ContactForm />
    </div>

  </div>
</template>

<script>
import Card from "@/components/Card.vue";
import ContactForm from "@/components/ContactForm.vue";
import Description from "@/components/Description.vue";
import FAQTitle from "@/components/FAQTitle.vue";
import Hero from "@/components/Hero.vue";
import Photo from "@/components/Photo.vue";
import Title from "@/components/Title.vue";

export default {
  name: "R2RProperty",
  components: {
    Card,
    ContactForm,
    Description,
    FAQTitle,
    Hero,
    Photo,
    Title
  },
  data() {
    return {
      FAQ: [
        {
          question: `How does “Rent to Rent” or “Guaranteed Rent” work?`,
          answer: `“Guaranteed Rent” also known as “Rent to Rent” is where an individual or company takes an interest in a property for a period of time from a landlord and guarantees to pay a fixed rent to the landlord. The landlord gives consent to the third party, ‘the Renter’, to then rent the property to other tenants. The Renter and they become the tenant liable for the rent. There are several ways to legally sublet a property, usually involving commercial or corporate tenancies, management agreements, and leases or guaranteed rent schemes.
<br />
<br />
So essentially, we set up an agreement with yourselves and you lease the property to DOD Property Services. Every month, we guarantee to pay you the agreed upon rental value. The Housing Association are a company who we are partnered with and they are what we call “Registered Social Landlords” This is a general name for a non-profit housing provider approved and regulated by the Government through the Homes & Communities Agency. The vast majority of Registered Social Landlords are known as Housing Associations.
<br />
<br />
Our affiliated Housing Association runs a supported housing scheme which supports a wide range of people, including those who are made suddenly homeless, people with learning disabilities, those coming out of foster care or fleeing domestic violence. They do not currently house people who are considered higher risk. The Housing Association are an approved body working with local authorities to then house these people in need on both short term and long term basis.
<br />
<br />
DOD Property Services and our affiliated Housing Association are partnered together as this is a cohesive relationship. DOD is an established property maintenance business that does the letting and takes care of all of the maintenance and responsibility for the property so that the Housing Association is then able to do its job and make sure there are suitable environments set up for those people who need it most. We will only use your property for this purpose, it will not be privately rented to any other person or agency.`
        },
        {
          question:
            "Why do landlords choose to use Guaranteed Rent rather than a traditional letting?",
          answer: `The benefits of the arrangement to the landlord is that their rental income is guaranteed regardless of whether the tenants who live at the property pay the rent or if the property becomes empty. The ‘Renter’ would generally also take care of any damage to the property as it is their responsibility to return the property back to the landlord in the same condition as when they took it. This all gives the landlord peace of mind.
<br />
<br />
This is where our years of expertise in property maintenance come into play and we do exactly that! We inspect the property on a monthly basis, take care of any maintenance issues as the property is occupied. The only thing we would expect you to cover is any structural issues i.e. roofing repairs with the property or boiler breakdown. We can take care of these issues on behalf of the owner, which takes the stress away, and it’s all included in our service.
<br />
<br />
Then when the lease agreement is complete, we make sure the house is handed back exactly as it was handed over with all decorating re-done so it looks brand new! So not only do you get your usual agreement as you do with usual tenants, but we go that extra mile to spruce up and look after your home. We also change the locks on the property front and back doors, just to be sure in case any keys have gotten lost. If there were any issues with the property, this would be the direct responsibility of DOD Property Services and would be chargeable to the company.`
        },
        {
          question: "How long is the Guaranteed Rental Period for?",
          answer: `We ask you to sign a minimum of a 3 years agreement with us at DOD Property Services as this is the time frame we have to uphold with the Housing Association. We do both 3 years and 5 years “Guaranteed Rent Agreements”.`
        },
        {
          question:
            "Would any changes have to be made to the property and are there any costs to me?",
          answer: `Yes, we would need your agreement to make a few minor changes. This is in regards to fire doors and fire alarms in the property. We would need to change all internal doors to ensure that they are fire doors which uphold certain regulatory requirements and ensure that there are fire alarms fitted in every room. This would be at no cost to you. An average cost to carry out this work would be approximately £1500 and this is covered by DOD Property Services. When your agreement is complete, you can either chose to keep the doors and alarms in place (there will be no additional charge) or these can be removed at your request.`
        },
        {
          question: "Do you need an HMO (House of Multiple Occupancy) License?",
          answer: `No. Neither yourself nor DOD needs any license as the Housing Association are an RSL have all of the necessary licensing to be able to have multiple occupants at one time which is permitted through the local authorities. They are only registered in Birmingham so we can only take on houses that have a “B” postcode.`
        },
        {
          question:
            "Is there an minimum amount of rooms that we need in order to be able to qualify?",
          answer: `Yes, any properties that we take on needs to have a minimum of 2 bedrooms and a separate downstairs room which is not connected to dining/communal area and does not require access through there to get in or out of the property. There is no maximum number of rooms. We can also take more than one property at a time off your hands so if you have multiple properties then this will create a great rental guarantee for yourselves.`
        },
        {
          question: "What legal issues should the parties consider?",
          answer: `The agreement between yourselves and DOD is of a commercial nature so a lease will need to be drawn up for the property for the period of time the DOD is going to pay the Guaranteed Rent. This will cover clear and unambiguous terms of business as to exactly how much DOD is due to pay you as the landlord and the outline of what we are responsible for in terms of the management of the property and compliance with the various legislation related to renting property.`
        },
        {
          question: "How long does the process take?",
          answer: `Just like any rental, this would go through any standard channels/procedures that you have in place and would work in the same way as any letting that you would do. The only additional requirement would be that a lease is drawn up, which can be provided by DOD Property Services or by yourself.`
        }
      ]
    };
  }
};
</script>

<style scoped>
#interested {
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.card-header {
  background-color: #1fa5d9;
  border-radius: 4px;
}

.card-header-title {
  font-size: 1.5rem;
}

ul {
  list-style: disc;
  padding: 2rem 0;
}

li {
  text-align: left;
}

.wrapper {
  margin-bottom: 2rem;
}
</style>
